/**
 * @file Reads `parameters/analytics` for a tab panel through
 * `useStoreDocsByPaths`, so each panel's listener is its own first connector.
 * Consumers: `AnalyticsOrdersPanel` and `AnalyticsInvoicingPanel`, for the
 * time zone, `openItems` and line item status lists, and `useHomeMyTasks`, for
 * `formDueDateField`. `parameters` is
 * `undefined` both while loading and when the document is absent; `loading`
 * tells the two apart.
 */
import { ANALYTICS_PARAMETERS_PATH, type AnalyticsParameters } from '#types';
import { useStoreDocsByPaths } from '@/store';

const PARAMETERS_PATHS = [ANALYTICS_PARAMETERS_PATH];

export const useAnalyticsParameters = (): {
  parameters: Partial<AnalyticsParameters> | undefined;
  loading: boolean;
} => {
  const { data, loading } =
    useStoreDocsByPaths<Partial<AnalyticsParameters>>(PARAMETERS_PATHS);
  return { parameters: data.get(ANALYTICS_PARAMETERS_PATH), loading };
};
